export enum Routes {
  Default = '',
  Welcome = 'welcome',
  GameOver = 'game-over',
}
